import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/brand";
import Reveal from "./Reveal";

const Encomendas = () => {
  return (
    <section id="encomendas" className="bg-cream py-24 lg:py-28">
      <div className="mx-auto max-w-[1400px] px-5">
        <Reveal>
          <div className="relative rounded-[2.5rem] overflow-hidden">
            <img src="https://images.unsplash.com/photo-1621868402792-a5c9fa6866a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="Encomendas Deco Sweet" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-choco/80" />
            <div className="relative z-10 px-8 sm:px-16 py-20 lg:py-28 text-center text-cream max-w-2xl mx-auto">
              <p className="text-xs uppercase tracking-luxe text-gold mb-4">Encomendas</p>
              <h2 className="font-serif text-4xl sm:text-5xl leading-tight mb-5">Vamos adoçar o seu dia?</h2>
              <p className="text-cream/75 leading-relaxed mb-9">
                Bolos, doces finos e mesas personalizadas para aniversários, casamentos e todos os momentos que merecem ser celebrados. Chame no WhatsApp e faça sua encomenda com praticidade.
              </p>
              <motion.a whileHover={{ scale: 1.04 }} href={waLink()} data-testid="encomendas-cta"
                className="inline-flex items-center gap-3 rounded-full bg-gold text-choco px-9 py-4 text-sm font-semibold uppercase tracking-widest">
                <MessageCircle size={18} /> Chamar no WhatsApp
              </motion.a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Encomendas;
